export default "__VITE_ASSET__CEQAYVfz__"